import { Outlet, useLocation } from 'react-router'
import { getOperatorContext } from '../../server/lib/loader-context'
import { SiteFooter } from '../components/layout/site-footer'
import { SiteHeader } from '../components/layout/site-header'
import { SelfServiceShell } from '../components/layout/self-service-shell'
import { isSelfServiceWorkspacePath } from '../lib/self-service-navigation'
import { Flex, styled } from '../styled-system/jsx'
import type { Route } from './+types/_site'

export async function loader({ request }: Route.LoaderArgs) {
    const operator = await getOperatorContext(request)
    return {
        currentDate: new Intl.DateTimeFormat('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(new Date()),
        user: operator
            ? { name: operator.user.name, email: operator.user.email }
            : null,
    }
}

export default function SiteLayout({ loaderData }: Route.ComponentProps) {
    const location = useLocation()
    const isWorkspaceRoute = isSelfServiceWorkspacePath(location.pathname)

    if (loaderData.user && isWorkspaceRoute) {
        return (
            <SelfServiceShell currentDate={loaderData.currentDate} user={loaderData.user}>
                <Outlet />
            </SelfServiceShell>
        )
    }

    return (
        <Flex minH="dvh" flexDirection="column" bg="brand.jet" color="fg.default">
            <SiteHeader user={loaderData.user} />
            <styled.main id="site-content" flex="1" minW="0">
                <Outlet />
            </styled.main>
            <SiteFooter />
        </Flex>
    )
}
